import React from 'react';
import { Progress } from '../../../components/app2';

/**
 * Uso de empleados contra el límite del plan (rediseño jul-2026).
 *
 * Mismas reglas de color de siempre:
 *   0–70 % normal · 70–90 % advertencia · más de 90 % o con sobrecupo, alerta.
 */
const UsageBar = ({ used = 0, limit, hidden = 0 }) => {
  const limitIsUnbounded = limit == null;
  const effectiveLimit = limitIsUnbounded ? Math.max(used, 1) : Math.max(limit, 1);
  const percent = Math.min(100, Math.round((used / effectiveLimit) * 100));
  const isOverage = hidden > 0;

  const color = isOverage || percent >= 90
    ? 'var(--danger)'
    : percent >= 70 ? 'var(--warn)' : 'var(--brand)';

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: 12, marginBottom: 8 }}>
        <span style={{ font: "500 .86rem 'Hanken Grotesk'", color: 'var(--muted)' }}>
          Empleados activos
        </span>
        <span style={{ font: "500 .86rem 'Hanken Grotesk'", color: 'var(--heading)' }}>
          <strong className="a2-serif" style={{ fontSize: '1.15rem', fontWeight: 600 }}>{used + hidden}</strong>
          {' / '}
          {limitIsUnbounded ? 'sin límite' : limit}
        </span>
      </div>

      <Progress
        value={percent}
        color={color}
        label="Uso de empleados contra el límite del plan"
      />

      {isOverage ? (
        <p style={{ font: "500 .78rem 'Hanken Grotesk'", color: 'var(--danger)', margin: '8px 0 0' }}>
          {hidden} {hidden === 1 ? 'empleado' : 'empleados'} no {hidden === 1 ? 'es' : 'son'}{' '}
          visible{hidden === 1 ? '' : 's'} bajo tu plan actual.
        </p>
      ) : null}
    </div>
  );
};

export default UsageBar;
